import { ReactNode } from 'react';

/**
 * Создает массив маршрутов для пути: один без языкового префикса, один с префиксом
 * Примеры:
 * - createLangRoutes('/about/', <AboutPage />) -> [{ path: '/about/', element: <AboutPage /> }, { path: '/:lang/about/', element: <AboutPage /> }]
 *
 * Это позволяет поддерживать оба варианта URL:
 * - /about/ (без префикса, английский)
 * - /de/about/ (с префиксом, немецкий)
 */
export const createLangRoutes = (path: string, element: ReactNode) => {
  if (path === '/') {
    return [
      { index: true, element },
      { path: ':lang', element },
    ];
  }
  // Убираем ведущий слэш для обработки
  const pathWithoutSlash = path.startsWith('/') ? path.slice(1) : path;
  // Возвращаем оба варианта: без префикса и с префиксом
  return [
    { path, element },
    { path: `/:lang/${pathWithoutSlash}`, element },
  ];
};
